import React from "react";
import DocumentCraftingSettings from "../Components/DocumentCrafting/Settings/DocumentCraftingSettings";

const DocumentCraftingSettingsPage: React.FC = () => <DocumentCraftingSettings />;

export default DocumentCraftingSettingsPage;
